export const CHANGE_AVAILABILITY_TIME_FILTER = 'change-availability-time-filter';
export const CHANGE_DATE = 'change-date';
export const CHANGE_DOCTOR_LOCATION_IDS = 'change-doctor-locations';
export const CHANGE_GRID_TYPE = 'change-grid-type';
export const CHANGE_INSURANCE = 'change-insurance';
export const CHANGE_IS_EXISTING_PATIENT = 'change-is-existing-patient';
export const CHANGE_PROCEDURE = 'change-procedure';
export const CHANGE_SELECTED_TIMESLOT = 'change-selected-timeslot';
